// Ensure base URL never has a trailing slash
export const API_BASE_URL = (import.meta.env.VITE_BASE_API_URL || 'http://localhost:5000').replace(/\/+$/, '');
